
import { connect } from 'react-redux';

import { setMapPoints } from '../actions/Map';
import { getTratList, setFilter } from '../actions/TratList';
import { getFilteredTratList } from '../reducers/tratList';
import TratListPage from '../components/TratListPage';

function mapDispatchToProps() {
    return {
        getTratList,
        setFilter,
        setMapPoints
    };
}

function mapStateToProps(state) {
    return {
        tratList: state.tratList,
        filteredTratList: getFilteredTratList(state.tratList),
        tratFilter: state.tratList.filter
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(TratListPage);
